function updateUrlWithSort(sortValue) {
  const currentUrl = window.location.href;
  const newUrl = new URL(currentUrl);
  const searchParams = newUrl.searchParams;

  searchParams.set('sort_by', sortValue);
  searchParams.set('page', 1);

  window.location.href = newUrl.toString();
  console.log(newUrl.searchParams.toString());
}

document.querySelectorAll('.sort-option').forEach(function(e) {
  e.addEventListener('click', function() {
    const sortValue = this.getAttribute('data-sort'); 
    updateUrlWithSort(sortValue);
  });
});

document.getElementById('sortForm').addEventListener('submit', function(e) {
  e.preventDefault();
  const selectedSortValue = document.querySelector('input[name="sort"]:checked').value;
  updateUrlWithSort(selectedSortValue);
});

const mobileModalToggle = async() => {
  return document.getElementById("modal-sort").classList.toggle("is-open");
};

document.addEventListener("DOMContentLoaded", () => {
  const sortButton = document.querySelectorAll(".-sortModalButton");
  sortButton.forEach((button) => {
    button.addEventListener("click", mobileModalToggle);
  });
});

document.body.addEventListener('click', function(event) {
  if (event.target.matches('.m-modalSort__headerClose')) {
    mobileModalToggle();
  }
});